import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Cookies from "js-cookie";
import API_ENDPOINTS from "../config/api";
import axios from "axios";
import { formatBuildingLabel } from "../utils/apartmentDisplay";

// 쿠키 설정 가져오기
const {
  KEYS: COOKIE_KEYS,
  EXPIRES: COOKIE_EXPIRES,
  OPTIONS: COOKIE_OPTIONS,
} = API_ENDPOINTS.COOKIE_CONFIG;

// 안드로이드 기기 체크
const isAndroid = /Android/i.test(navigator.userAgent);

// 페이지 애니메이션 변형 설정
const pageVariants = {
  initial: {
    opacity: 0,
    y: 30,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      type: "tween",
      ease: "easeOut",
      duration: 0.5,
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.3,
    },
  },
};

// 버튼 애니메이션 변형 설정
const buttonVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.3,
      duration: 0.5,
    },
  },
};

function SubmissionCompletePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showRestartModal, setShowRestartModal] = useState(false);

  // 파라미터로 전달된 공동소유자 대기 상태 확인
  const isWaitingCoOwner = location.state?.isWaitingCoOwner || false;

  // useEffect(() => {
  //   // 쿠키에서 user_info 가져오기
  //   const userInfoFromCookie = Cookies.get(COOKIE_KEYS.USER_INFO);

  //   if (!userInfoFromCookie) {
  //     navigate("/not-found");
  //     return;
  //   }

  //   try {
  //     const parsedUserInfo = JSON.parse(userInfoFromCookie);
  //     setUserInfo(parsedUserInfo);

  //     // 쿠키 재설정 (만료 시간 갱신)
  //     Cookies.set(COOKIE_KEYS.USER_INFO, JSON.stringify(parsedUserInfo), {
  //       expires: COOKIE_EXPIRES.USER_INFO,
  //       ...COOKIE_OPTIONS,
  //     });
  //   } catch (error) {
  //     navigate("/not-found");
  //   }
  // }, [navigate]);

  // 사용자 정보 포맷
  const formatUserData = () => {
    if (!userInfo) return {};

    return {
      dong: userInfo.apartmentBlock || "000",
      ho: userInfo.apartmentUnit || "0000",
      name: userInfo.residentName || "홍길동",
      apartment: userInfo.apartmentName || "000아파트",
    };
  };

  const userData = formatUserData();

  // if (!userInfo) {
  //   return null;
  // }

  // 다시 시작하기 모달 열기
  const openRestartModal = () => {
    setShowRestartModal(true);
  };

  // 다시 시작하기 모달 닫기
  const closeRestartModal = () => {
    setShowRestartModal(false);
  };

  const handleRestart = async () => {
    setIsLoading(true);
    setShowRestartModal(false);
    const accessToken = Cookies.get(COOKIE_KEYS.ACCESS_TOKEN);

    try {
      await axios({
        method: "DELETE",
        url: `${API_ENDPOINTS.BASE_URL}/mobile/claim`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      // 토큰을 파라미터로 포함하여 루트 경로로 이동
      const refreshToken = Cookies.get(COOKIE_KEYS.REFRESH_TOKEN);

      // 로컬 스토리지와 세션 스토리지 초기화
      localStorage.clear();
      sessionStorage.clear();

      window.location.replace(
        `/?accessToken=${accessToken}&refreshToken=${refreshToken}`
      );
    } catch (error) {
      alert("처리 중 오류가 발생했습니다. 다시 시도해주세요.");
      setIsLoading(false);
    }
  };

  // 현재 날짜 포맷팅 (YYYY-MM-DD HH:MM)
  const formatDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  return (
    <motion.div
      className="page-container"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{
        padding: "24px",
        backgroundColor: "#F7F7F7",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
      }}
    >
      <h1
        style={{
          fontSize: "22px",
          textAlign: "center",
          fontWeight: "600",
          marginTop: "16px",
          marginBottom: "8px",
        }}
      >
        상세 내역보기
      </h1>

      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "600",
              marginBottom: "12px",
            }}
          >
            {isWaitingCoOwner ? "채권양도양수 진행중" : "채권양도양수 완료"}
          </h2>
          <p
            style={{
              color: "#666",
              fontSize: "15px",
              lineHeight: "1.4",
            }}
          >
            {isWaitingCoOwner
              ? `${userData.name}님의 채권양도양수를 위한 공동소유자 전자서명을 대기중입니다. 공동소유자의 전자서명이 완료되면 처리가 완료됩니다.`
              : `${userData.name}님의 채권양도양수 처리가 완료되었습니다.`}
          </p>
        </div>

        <div
          style={{
            borderRadius: "8px",
            backgroundColor: "#F7F7F7",
            padding: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <span style={{ color: "#555", fontSize: "15px" }}>동/호수</span>
            <span style={{ fontWeight: "500", fontSize: "15px" }}>
              {formatBuildingLabel(
                userData.dong,
                Cookies.get("apartmentCode"),
              )}{" "}
              {userData.ho}호
            </span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <span style={{ color: "#555", fontSize: "15px" }}>소유자 성명</span>
            <span style={{ fontWeight: "500", fontSize: "15px" }}>
              {userData.name}
            </span>
          </div>

          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <span style={{ color: "#555", fontSize: "15px" }}>
              공동 소유자 명
            </span>
            <span style={{ fontWeight: "500", fontSize: "15px" }}>
              {userData.name}
            </span>
          </div> */}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: "#555", fontSize: "15px" }}>양수인</span>
            <span style={{ fontWeight: "500", fontSize: "15px" }}>
              {userData.apartment}{" "}
              {Cookies.get("apartmentCode") === "ForeonStation5"
                ? "관리단"
                : "입주자대표회의"}
            </span>
          </div>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h3 style={{ fontSize: "16px", fontWeight: "600" }}>처리 내역</h3>
          {isWaitingCoOwner ? (
            <span
              style={{
                backgroundColor: "#FEFEEA",
                color: "#ED6D3B",
                padding: "4px 12px",
                borderRadius: "100px",
                fontSize: "13px",
              }}
            >
              공동소유자 전자서명 대기중
            </span>
          ) : (
            <span
              style={{
                backgroundColor: "#E7F3FF",
                color: "#7A4FFF",
                padding: "4px 12px",
                borderRadius: "100px",
                fontSize: "13px",
              }}
            >
              완료됨
            </span>
          )}
        </div>

        <div
          style={{
            color: "#555",
            fontSize: "15px",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "12px",
          }}
        >
          <span>2025-03-26 15:30</span>
        </div>

        <div
          style={{
            borderTop: "1px solid #EFEFEF",
            paddingTop: "16px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            {/* <p style={{ color: "#777", fontSize: "14px", marginBottom: "8px" }}>
              접수번호
            </p> */}
            <p style={{ fontWeight: "500", fontSize: "14px" }}> 처리자</p>
          </div>
          <div style={{ textAlign: "right" }}>
            {/* <p style={{ color: "#777", fontSize: "14px", marginBottom: "8px" }}>
              처리자
            </p> */}
            <p style={{ fontWeight: "500", fontSize: "14px" }}>
              {userData.name}(본인)
            </p>
          </div>
        </div>
      </div>

      <div style={{ flex: 1 }}></div>

      <motion.div
        className="submission-button-container"
        variants={buttonVariants}
        initial="initial"
        animate="animate"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "460px",
          padding: "0 24px",
          margin: "0 auto",
        }}
      >
        {isWaitingCoOwner && (
          <button
            onClick={openRestartModal}
            disabled={isLoading}
            style={{
              width: "100%",
              padding: "16px",
              backgroundColor: "#7A4FFF",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "500",
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.7 : 1,
              marginBottom: "12px",
            }}
          >
            {isLoading ? "처리 중..." : "채권양도양수 다시 시작하기"}
          </button>
        )}

        <button
          onClick={openRestartModal}
          disabled={isLoading || isWaitingCoOwner}
          style={{
            width: "100%",
            padding: "16px",
            backgroundColor: isWaitingCoOwner ? "#FEFEEA" : "#7A4FFF",
            color: isWaitingCoOwner ? "#ED6D3B" : "white",
            border: isWaitingCoOwner ? "1px solid #ED6D3B" : "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: "500",
            cursor: isLoading || isWaitingCoOwner ? "not-allowed" : "pointer",
            opacity: isLoading ? 0.7 : 1,
            marginBottom: "24px",
          }}
        >
          {isLoading
            ? "처리 중..."
            : isWaitingCoOwner
            ? "공동소유자 전자서명 진행중"
            : "채권양도양수 다시 시작하기"}
        </button>
      </motion.div>

      {/* 다시 시작하기 확인 모달 */}
      {showRestartModal && (
        <div
          className="restart-modal-backdrop"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="restart-modal"
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "24px",
              width: "90%",
              maxWidth: "360px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            }}
          >
            <div className="restart-modal-header">
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  margin: 0,
                }}
              >
                채권양도양수 다시 시작
              </h3>
            </div>
            <div
              className="restart-modal-content"
              style={{ marginTop: "16px", marginBottom: "24px" }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: "16px",
                  lineHeight: "1.5",
                  color: "#4B5563",
                }}
              >
                정말 채권양도양수를 처음부터 다시 시작하시겠습니까?
                <br />이 작업은 되돌릴 수 없습니다.
              </p>
            </div>
            <div
              className="restart-modal-buttons"
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "8px",
              }}
            >
              <button
                className="restart-modal-button cancel"
                onClick={closeRestartModal}
                style={{
                  flex: 1,
                  padding: "12px",
                  backgroundColor: "#F3F4F6",
                  color: "#4B5563",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                취소하기
              </button>
              <button
                className="restart-modal-button delete"
                onClick={handleRestart}
                style={{
                  flex: 1,
                  padding: "12px",
                  backgroundColor: "#ED6D3B",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                다시 시작하기
              </button>
            </div>
          </div>
        </div>
      )}
    </motion.div>
  );
}

export default SubmissionCompletePage;
